<div #graphContainer>
  <svg #graph></svg>
</div>